<div class="mat-app-background app-container dark-theme">
  <ng-container *ngIf="(isLoggedIn$ | async) && (languageSettings$ | async) && languageWasSet; else loggedOut">
    <app-header class="header no-print" [version]="'footer' | translate:{'version': versionNumber}"></app-header>
    <app-modules-bar></app-modules-bar>
    <router-outlet></router-outlet>
    <app-footer class="footer no-print" [version]="'footer' | translate:{'version': versionNumber}"></app-footer>
  </ng-container>
  <ng-template #loggedOut>
<router-outlet *ngIf="router.url.includes('/login')"></router-outlet>
  </ng-template>
</div>
<p-toast position="center" delay="100" *ngIf="toastMessage$ | async"></p-toast>
<app-alert-minimized-list></app-alert-minimized-list>
